import React from 'react';
import { RateFee } from 'v1/components/shared';

const RatePayrollFee = ({ defaultValue = 20, ...otherProps }) => (
  <RateFee
    label="Add payroll fee"
    placeholder="Payroll fee"
    defaultValue={defaultValue}
    {...otherProps}
  />
);

export default RatePayrollFee;
